import { useRequest } from "hooks";
import type { ResourceResponse, ThunkReturnType } from "types";
import { ApiRouteTypes } from "consts/enpoints/api";
import useExportTable from "hooks/useExportTable";
import type { WaTemplatesSetupsResponse, WaTemplateSetup } from "../types";
import {
    getWaTemplatesSetupsThunk,
    createWaTemplatesSetupThunk,
    updateWaTemplatesSetupThunk
} from "../thunks";
import { changeExportWaTemplatesSetupsLoading as changeExportLoading } from "../slice";

export const useWaTemplatesSetupsActions = () => {
    const getWaTemplatesSetups = useRequest<
        ThunkReturnType<WaTemplatesSetupsResponse>,
        string | undefined
    >({
        thunk: getWaTemplatesSetupsThunk
    });

    const createWaTemplatesSetup = useRequest<
        ThunkReturnType<ResourceResponse<WaTemplateSetup>>,
        Partial<WaTemplateSetup>
    >({
        thunk: createWaTemplatesSetupThunk,
        shouldNotifyOnSuccess: true
    });

    const updateWaTemplatesSetup = useRequest<
        ThunkReturnType<ResourceResponse<WaTemplateSetup>>,
        Partial<WaTemplateSetup>
    >({
        thunk: updateWaTemplatesSetupThunk,
        shouldNotifyOnSuccess: true
    });

    const downloadCsv = useExportTable({
        changeExportLoading,
        apiResourceType: ApiRouteTypes.GetWaTemplatesSetups
    });

    return {
        getWaTemplatesSetups,
        createWaTemplatesSetup,
        updateWaTemplatesSetup,
        downloadCsv
    };
};

export default useWaTemplatesSetupsActions;
